import { init } from '@dash0/sdk-web';
import { setErrorTracker } from '@libs/logger';
import { isDash0Enabled } from './libs/observability/dash0-enabled';
import { dash0ClientErrorTracker } from './libs/observability/dash0-error-tracker.client';

/**
 * Next.js client instrumentation entry point — top-level code runs in the
 * browser before hydration, so it captures the full page load, early errors,
 * and Core Web Vitals. Initialization is guarded on the public Dash0 vars so
 * local dev / CI / the unauthenticated e2e preview (which have no token) boot
 * and behave exactly as before.
 *
 * The web-events ingest token is intentionally a `NEXT_PUBLIC_*` value: it ships
 * in the bundle, so it must be a Dash0 token restricted to the "web events"
 * signal type and scoped to the target dataset.
 */
const endpointUrl = process.env['NEXT_PUBLIC_DASH0_ENDPOINT_URL'] ?? '';
const authToken = process.env['NEXT_PUBLIC_DASH0_WEB_TOKEN'] ?? '';
const serviceVersion =
  process.env['NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA'] ?? 'dev';
const environment = process.env['NEXT_PUBLIC_VERCEL_ENV'] ?? 'development';

if (isDash0Enabled()) {
  init({
    serviceName: 'web-kruxit',
    serviceVersion,
    environment,
    endpoint: { url: endpointUrl, authToken },
  });
  setErrorTracker(dash0ClientErrorTracker);
}
